// extracted by mini-css-extract-plugin
module.exports = {"logotype":"logotype-module--logotype--1uApZ","courseLogoType":"logotype-module--courseLogoType--2fcJZ"};